import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "22",
        cy: "22",
        r: "22",
        fill: "var(--status-svg-color)"
      }),
      _createElementVNode("path", { d: "M9 9h26v26H9z" }),
      _createElementVNode("path", {
        fill: "#FFF",
        "fill-rule": "nonzero",
        d: "M22 33c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11m0-2.2a8.8 8.8 0 1 0 0-17.6 8.8 8.8 0 0 0 0 17.6m-1.1-7.929a2.75 2.75 0 1 1 2.2 0V26.4h-2.2z"
      })
    ], -1)
  ]))]))
}
export default { render: render }